export default "__VITE_ASSET__b8d6f00e__"